import request from '@/utils/request'

export default {
  login(info) {
    return request({
      url: '/gateway/user/user/login',
      method: 'post',
      data: info
    })
  },
  refreshToken(data) {
    return request({
      url: '/gateway/user/user/refreshToken',
      method: 'post',
      data: data
    })
  },
  logout() {
    return request({
      url: '/vue/logout',
      method: 'post'
    })
  },
  findPeriodPlanAndNameAndOrderByCompanyId() {
    return request({
      url: '/gateway/core/diningHallPeriodPlan/findPeriodPlanAndNameAndOrderByCompanyId',
      method: 'get'
    })
  },
  findPeriodPlanFoodListByPeriodNameIdAndQueryTime(params) {
    return request({
      url: `/gateway/core/diningHallPeriodPlan/findPeriodPlanFoodListByPeriodNameIdAndQueryTime`,
      method: 'get',
      params: params
    })
  },
  queryShoppingCartPayOrderJoinActivityList(params, data) {
    return request({
      url: `/gateway/order/placeOrder/queryShoppingCartPayOrderJoinActivityList`,
      method: 'post',
      params: params,
      data: data
    })
  },
  shoppingCartPayByHandBank(params, data) {
    return request({
      url: `/gateway/order/placeOrder/shoppingCartPayByHandBank`,
      method: 'post',
      params: params,
      data: data
    })
  },

  addOrder(userInfo, data) {
    return request({
      url: '/vue/addOrder',
      method: 'post',
      params: userInfo,
      headers: {
        'token': userInfo.token
      },
      data: data
    })
  },
  findOrderByHandheldBankPageList(userInfo, params) {
    return request({
      url: '/gateway/order/userOrder/findOrderByHandheldBankPageList',
      method: 'get',
      params: params
    })
  },
  queryConsumeOrders(userInfo, start, end) {
    const params = {
      companyId: userInfo.companyId,
      userId: userInfo.userId,
      start: start,
      end: end
    }
    return request({
      url: '/vue/queryConsumeOrders',
      method: 'get',
      params: params,
      headers: {
        'token': userInfo.token
      }
    })
  },
  findUserRechargeNotReceivedList(userInfo, page) {
    return request({
      url: '/gateway/user/userRecharge/findUserRechargeNotReceivedList',
      method: 'get',
      params: {
        userName: '',
        startTime: -9999,
        endTime: -9999,
        page: page,
        pageSize: 50
      },
      headers: {
        'token': userInfo.token
      }
    })
  },
  queryRecharges(userInfo, start, end) {
    const params = {
      companyId: userInfo.companyId,
      userId: userInfo.userId,
      start: start,
      end: end
    }
    return request({
      url: '/vue/queryRecharges',
      method: 'get',
      params: params,
      headers: {
        'token': userInfo.token
      }
    })
  },
  findOrderDetailsByHandheldBank(params) {
    return request({
      url: '/gateway/order/order/findOrderDetailsByHandheldBank',
      method: 'get',
      params: params
    })
  },
  getRepastQrCode() {
    return request({
      url: '/gateway/user/user/getRepastQrCode',
      method: 'get'
    })
  },
  findUserAbcSpecialByHandBank() {
    return request({
      url: '/gateway/user/userAbcSpecial/findUserAbcSpecialByHandBank',
      method: 'get'
    })
  },
  queryUserAddressPageList(params) {
    return request({
      url: '/gateway/user/userAddress/queryUserAddressPageList',
      method: 'get',
      params: params
    })
  },
  addUserAddress(params, data) {
    return request({
      url: '/gateway/user/userAddress/addUserAddress',
      method: 'post',
      params: params,
      data: data
    })
  },
  abcUerRechargeCompensate(params, data) {
    return request({
      url: '/gateway/user/userABCRecharge/abcUerRechargeCompensate',
      method: 'post',
      params: params,
      data: data
    })
  },
  identityCard(params, data) {
    return request({
      url: '/gateway/core/sys/oss/upload/identityCard',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
        token: params.accessToken
      },
      data: data
    })
  },
  verifycode(params, data) {
    return request({
      url: '/gateway/user/userAbcSpecial/verifycode',
      method: 'post',
      data: data
    })
  },
  openeaccount(params, data) {
    return request({
      url: '/gateway/user/userAbcSpecial/openeaccount',
      method: 'post',
      data: data
    })
  },
  updateUserAddress(params, data) {
    return request({
      url: '/gateway/user/userAddress/updateUserAddress',
      method: 'post',
      params: params,
      data: data
    })
  },
  deleteUserAddress(params, data) {
    return request({
      url: '/gateway/user/userAddress/deleteUserAddress',
      method: 'post',
      params: params,
      data: data
    })
  },
  cancelOrderByHandheldBank(params, data) {
    return request({
      url: '/gateway/order/order/cancelOrderByHandheldBank',
      method: 'post',
      params: params,
      data: data
    })
  },
  handBankPay(params, data) {
    return request({
      url: '/gateway/order/payOrder/handBankPay',
      method: 'post',
      params: params,
      data: data
    })
  },
  findUserHistoryBillById(params) {
    return request({
      url: '/gateway/user/userAccount/findUserHistoryBillById',
      method: 'get',
      params: params
    })
  },
  useMessage(params) {
    return request({
      url: '/gateway/user/user/useMessage',
      method: 'get',
      params: params
    })
  },
  selectPaySettingByCompanyId() {
    return request({
      url: '/gateway/core/companyMobileBankingPaySetting/selectPaySettingByCompanyId',
      method: 'get'
    })
  },
  queryPeriodDeliveryTimeListByPeriodId(params) {
    return request({
      url: '/gateway/core/diningHallPeriodDeliveryTime/queryPeriodDeliveryTimeListByPeriodId',
      method: 'get',
      params: params
    })
  },
  queryCompanyAddressList() {
    return request({
      url: '/gateway/core/companyAddress/queryCompanyAddressList',
      method: 'get'
    })
  },
  getVerificationCode2(phoneNumber) {
    return request({
      url: '/vue/getVerificationCode2',
      method: 'get',
      params: {
        phoneNumber
      }
    })
  },
  updateUserPassword(params, data) {
    return request({
      url: '/gateway/user/user/updateUserPassword',
      method: 'post',
      params: params,
      data: data
    })
  },
  updateUserPhone(params, data) {
    return request({
      url: '/gateway/user/user/updateUserPhone',
      method: 'post',
      params: params,
      data: data
    })
  },
  updateUser(params, data) {
    return request({
      url: '/gateway/user/user/updateUser',
      method: 'post',
      params: params,
      data: data
    })
  },
  sendUserSmsOfUpdatePassword(params, data) {
    return request({
      url: '/gateway/user/user/sendUserSmsOfUpdatePassword',
      method: 'post',
      params: params,
      data: data
    })
  },
  sendUserSmsOfForgetPassword(params, data) {
    return request({
      url: '/gateway/user/user/sendUserSmsOfForgetPassword',
      method: 'post',
      params: params,
      data: data
    })
  },
  findUserBillRecordDetails(params) {
    return request({
      url: '/gateway/user/userAccount/findUserBillRecordDetails',
      method: 'get',
      params: params
    })
  },
  findUserRechargeBillByRechargeNo(params) {
    return request({
      url: '/gateway/user/userRecharge/findUserRechargeBillByRechargeNo',
      method: 'get',
      params: params
    })
  },
  forgetPassword(params, data) {
    return request({
      url: '/gateway/user/user/forgetPassword',
      method: 'post',
      params: params,
      data: data
    })
  },
  addFace(userInfo, params) {
    return request({
      url: '/vue/createFace',
      method: 'post',
      data: params,
      headers: {
        'token': userInfo.token
      }
    })
  },
  updateUserFace(userInfo, params) {
    return request({
      url: '/gateway/user/userFace/updateUserFace',
      method: 'post',
      data: params
    })
  },
  deleteUserFace() {
    return request({
      url: '/gateway/user/userFace/deleteUserFace',
      method: 'post',
      data: {}
    })
  },
  updateUserOfFreeze(userInfo, params) {
    return request({
      url: '/gateway/user/user/updateUserOfFreeze',
      method: 'post',
      data: params
    })
  },
  queryCompanyCommentTagPageListAll(params) {
    return request({
      url: '/gateway/core/companyCommentTag/queryCompanyCommentTagPageListAll',
      method: 'get',
      params: params
    })
  },
  addOrderComment(userInfo, params) {
    return request({
      url: '/gateway/order/orderComment/addOrderComment',
      method: 'post',
      data: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js